<app-loading-spinner *ngIf="loading"></app-loading-spinner>
